import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import SEO from '@/components/base/SEO';
import Breadcrumb from '@/components/base/Breadcrumb';
import MovieCard from '@/components/feature/MovieCard';
import { movies, categories } from '@/mocks/movies';
import { getWebPageSchema, getBreadcrumbSchema } from '@/utils/schema';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'all';

  const currentCategory = categories.find((c) => c.slug === currentSlug);
  const categoryName = currentCategory?.name || '全部';

  const filteredMovies = currentSlug === 'all'
    ? movies
    : movies.filter((m) => m.category === currentSlug);

  const pageTitle = `${categoryName} - 高清${categoryName}免费在线观看`;
  const pageDesc = `春色影视${categoryName}专区，提供海量高清${categoryName}资源免费在线观看。最新${categoryName}每日更新，流畅播放不卡顿，随时随地畅享精彩${categoryName}内容。`;

  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: categoryName },
  ];

  const webPageSchema = getWebPageSchema(
    pageTitle,
    pageDesc,
    `https://chunse.yingshi.com/category/${currentSlug}`,
    getBreadcrumbSchema([
      { name: '首页', url: 'https://chunse.yingshi.com' },
      { name: categoryName, url: `https://chunse.yingshi.com/category/${currentSlug}` },
    ]).itemListElement
  );

  return (
    <>
      <SEO
        title={`${categoryName}专区`}
        description={pageDesc}
        keywords={`春色影视${categoryName},免费${categoryName},高清${categoryName}在线观看,${categoryName}大全,${categoryName}推荐`}
        canonicalUrl={`https://chunse.yingshi.com/category/${currentSlug}`}
        schema={webPageSchema}
      />

      <Navbar />

      <main className="max-w-7xl mx-auto px-4 md:px-6 py-6">
        <Breadcrumb items={breadcrumbItems} />

        {/* Category Header */}
        <div className="mb-8">
          <h1 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">
            {categoryName}专区
          </h1>
          <p className="text-sm text-foreground-500">
            共找到 <strong className="text-primary-500 font-semibold">{filteredMovies.length}</strong> 部{categoryName}资源
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                currentSlug === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-400 hover:text-foreground-200 hover:bg-background-200/70 border border-background-200/50'
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={cat.icon}></i>
              </span>
              {cat.name}
            </Link>
          ))}
        </div>

        {/* Content Grid */}
        {filteredMovies.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {filteredMovies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-20 text-center">
            <div className="w-16 h-16 flex items-center justify-center mb-4">
              <i className="ri-emotion-sad-line text-4xl text-foreground-600"></i>
            </div>
            <p className="text-foreground-500 text-sm">暂无该分类的影视资源</p>
            <Link
              to="/category/all"
              className="mt-4 text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              查看全部内容
            </Link>
          </div>
        )}
      </main>

      <Footer />
    </>
  );
}